import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=2484e251&scoped=true&"
import script from "./Slideshow.vue?vue&type=script&lang=js&"
export * from "./Slideshow.vue?vue&type=script&lang=js&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=2484e251&scoped=true&lang=css&"
import style1 from "./Slideshow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484e251",
  null
  
)

export default component.exports